import { Base64 } from "js-base64";

export default {
  encodeLoginPassword(pwd) {
    const res = Base64.encode(pwd);
    return res.slice(0, 1) + Base64.encode(this.PrefixZero(Math.floor(Math.random() * 1000), 3)) + res.slice(0, -1) + Base64.encode(this.PrefixZero(Math.floor(Math.random() * 1000), 3)) + res.slice(res.length - 1);
  },
  PrefixZero(num, n) {
    return (Array(n).join(0) + num).slice(-n);
  }
}